import React from 'react';
import { Box, Flex, Select, Button, Text, Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { FaSearch } from 'react-icons/fa';

const FiltrosBusca = ({ filtros, onFiltroChange, onBuscar, isLoading }) => {
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        onFiltroChange({ [name]: value });
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            onBuscar();
        }
    };

    return (
        <Box>
            <Text ml={4} mt={2} mb={2} color={"#F68633"} fontWeight={"bold"} fontSize={"16px"} textAlign="start">
                FILTROS
            </Text>
            <Flex direction={{ base: "column", md: "row" }} gap={2} ml={2} align="center">
                <InputGroup w={{ base: "full", md: "300px" }}>
                    <InputLeftElement pointerEvents="none">
                        <FaSearch color="gray.300" />
                    </InputLeftElement>
                    <Input
                        name="anuncioId"
                        placeholder="Pesquisar por ID do Anúncio"
                        boxShadow='sm'
                        value={filtros.anuncioId}
                        onChange={handleInputChange}
                        onKeyDown={handleKeyDown}
                    />
                </InputGroup>
                <Select
                    name="conta"
                    w={{ base: "full", md: "200px" }}
                    boxShadow='sm'
                    value={filtros.conta}
                    onChange={handleInputChange}
                >
                    <option value="all">Todas as Contas</option>
                    <option value="1">Conta 1</option>
                    <option value="2">Conta 2</option>
                    <option value="3">Conta 3</option>
                </Select>
                <Select
                    name="status"
                    w={{ base: "full", md: "200px" }}
                    boxShadow='sm'
                    value={filtros.status}
                    onChange={handleInputChange}
                >
                    <option value="unanswered">A responder</option>
                    <option value="answered">Respondidas</option>
                </Select>
                <Button
                    bg={"#01695E"}
                    color={"white"}
                    _hover={{ bg: "white", color: "black" }}
                    onClick={onBuscar}
                    boxShadow='lg'
                    isLoading={isLoading}
                    px={8}
                    w={{ base: "full", md: "auto" }}
                >
                    Buscar
                </Button>
            </Flex>
        </Box>
    );
};

export default FiltrosBusca;
